import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.41 9H20V11H13V4H15V7.59L20.59 2L22 3.41L16.41 9ZM9 13H4V15H7.59L2 20.59L3.41 22L9 16.41V20H11V13H9Z" fill={ fill || 'currentColor' } />
    </svg>
);
